import { useState } from "react";
import { CHANGELOG_VERSION, CHANGELOG_STORAGE_KEY, CHANGELOG_ENTRIES } from "@/lib/changelog";

function shouldShowChangelog(): boolean {
  if (CHANGELOG_ENTRIES.length === 0) return false;
  try {
    return localStorage.getItem(CHANGELOG_STORAGE_KEY) !== CHANGELOG_VERSION;
  } catch {
    return false;
  }
}

export function useWhatsNew() {
  const [open, setOpen] = useState<boolean>(shouldShowChangelog);

  function dismiss() {
    try {
      localStorage.setItem(CHANGELOG_STORAGE_KEY, CHANGELOG_VERSION);
    } catch {
      // Storage write failed — still close the modal
    }
    setOpen(false);
  }

  return { open, dismiss };
}
